<script>
  import { onMount, getContext } from "svelte";
  import { navigate, Link } from "svelte-routing";
  import { Button, Input, Spinner, Table } from "sveltestrap";
  import Icon from "svelte-awesome";
  import {
    filter as filterIcon,
    sort,
  } from "svelte-awesome/icons";

  import axios from "axios";

  import DataSpinner from "../Spinner.svelte";
  import SucessPTO from "./SucessPTOContainer.svelte";
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import ColumnFilterModal from '../ColumnFilterModal.svelte';


  export let startDate = null;
  export let endDate = null;
  export let staffId = '';
  export let teamId = '';
  export let filter = '';

  export let refreshData = false;
  $: {
    if (refreshData) {
      FetchData();
      refreshData = false;
    }
  };

  let fetching = false;
  let data = [];

  let displayedData = [];
  let filteredFields = {};
  let sortStates = {};
  let columnFilterModal = { open: () => {} };

  const { showForm } = getContext('pto');

  export function FetchData() {
    fetching = true;

    const teamStaffFilter = filter === 1 ? `teamid=${teamId}`
      : filter === 2 ? `staffid=${staffId}`
      : '';

    axios
      .get(`/requestPTOapi/GetPTOs?startdate=${startDate}&enddate=${endDate}&${teamStaffFilter}&filter=${filter}`)
      .then(function(res) {
        data = res.data.Result;
        displayedData = data;
      })
      .catch(function(err) {
        console.log(err);
      })
      .finally(function () {
        fetching = false;
      });
  }

  function DateAndHours() {
    listDate = [];
    listHours = [];
    startDate = startDate;

    var date = document.getElementsByName("date[]");

    for (var i = 0; i < date.length; i++) {
      listDate.push(date[i].value);
    }
    var hours = document.getElementsByName("hours[]");

    for (var i = 0; i < hours.length; i++) {
      if (hours[i].value != "") {
        listHours.push(hours[i].value);
      }
    }

    if (hours.length == listHours.length) {
      hoursFilledUp = true;
    } else {
      hoursFilledUp = false;
    }
  }

  function getDifDays() {
    listDateFormat = [];
    const start = new Date(startDate + " ");
    const end = new Date(endDate + " ");
    const difTime = end.getTime() - start.getTime();
    const arrdate = [];
    difDays = difTime / (1000 * 3600 * 24) + 1;
    for (var i = 0; i < difDays; i++) {
      if (i == 0) {
        listDateFormat.push(start.setDate(start.getDate()));
      } else {
        listDateFormat.push(start.setDate(start.getDate() + 1));
      }
    }

    console.log(listDateFormat);
    console.log(difDays);
  }

  function submit() {
    DateAndHours();
    loading = true;
    var bodyFormData = new FormData();
    bodyFormData.set("StartDate", startDate);
    bodyFormData.set("EndDate", endDate);
    bodyFormData.set("TimeOffType", timeOffType);
    bodyFormData.set("Date", listDate);
    bodyFormData.set("Hours", listHours);
    bodyFormData.set("Notes", notes);
    axios({
      method: "post",
      url: "/RequestPTOApi/SendRequest",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        loading = false;
        sucess = true;
      })
      .catch(function(response) {
        console.log(response);
      });
  }

  function updateFilters(field, value) {
    filteredFields = filteredFields || {};
    filteredFields[field] = value;
    filteredFields = filteredFields;
    displayedData = data.filter(filterData).sort((a, b) => compareFields(a, b, field));
  }

  function sortData(field) {
    sortStates[field] = !sortStates[field];
    displayedData = data.filter(filterData).sort((a, b) => compareFields(a, b, field));
  }

  function compareFields(a, b, fieldName) {
    // Use toUpperCase() to ignore character casing
    const lhs = `${a[fieldName]}`.toUpperCase();
    const rhs = `${b[fieldName]}`.toUpperCase();

    const comparison = lhs > rhs ? 1
      : lhs < rhs ? -1
      : 0;

    return sortStates[fieldName] ? comparison : comparison * -1;
  }

  function filterData(item) {
    let isMatch = true;

    for (const key in filteredFields) {
      if (filteredFields.hasOwnProperty(key)) {
        const searchTerm = (filteredFields[key] || '').toLowerCase();

        let fieldRawValue = '';
        switch (key) {
          default:
            fieldRawValue = item[key] || '';
            break;
        }

        const fieldValue = fieldRawValue.toString().toLowerCase();

        isMatch = isMatch && fieldValue.includes(searchTerm);
      }
    }

    return isMatch;
  }

  function showColumnFilterModal(field, value) {
    columnFilterModal.show(field, value, filteredFields[field]);
  }

  function GetDownloadUrl() {
    const teamStaffFilter = filter === 1 ? `teamid=${teamId}`
      : filter === 2 ? `staffid=${staffId}`
      : '';

    return `/requestPTOapi/GetPTOReport?startdate=${startDate}&enddate=${endDate}&${teamStaffFilter}&filter=${filter}`;
  }

</script>

<style>
  input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
  }
  select {
    width: 50%;
    padding: 10px;
    border-radius: 5px;
  }
  .row {
    margin: 15px 0px;
  }
  button {
    padding: 10px 5px;
    border-radius: 5px;
    background-color: #3498db;
    color: white;
  }

  th {
    background-color: #223646;
    color: white;
  }
  .header-label {
    cursor: pointer;
  }

  .request-pto-list {
    width: 100%;
    overflow: auto;
    padding: 0px 30px;
  }

  .request-pto-list th {
    background-color: #223646;
    color: white;
  }

  .request-row {
    display: flex;
    flex-direction: column;
  }

  .no-result-container {
    text-align: center;
  }

  .res-view-title {
    display: none;
  }
  @media (max-width: 768px) {
    .request-row {
      display: unset;
    }
    .request-pto-list {
      width: 100%;
      padding: 0px;
      border: 1px solid #ced4da;
      height: 450px;
      overflow: auto;
      margin-bottom: 30px;
    }
    .res-view-title {
      display: block;
    }
  }
</style>

<div class="timesite-container">
  <div style="display: flex; justify-content: space-between; padding: 0px 30px 10px 30px;">
    <button class="btn-flat" on:click={showForm}>
      <span class="fa fa-arrow-left"></span> Back
    </button>
    <a href={GetDownloadUrl()}>
      <button class="btn-flat {!startDate || !endDate ? 'disabled' : ''}">
        <span class="fa fa-download"></span> Download
      </button>
    </a>
  </div>
  <div class="request-row">
    {#if fetching}
      <DataSpinner />
    {:else}
      <div class="request-pto-list">
        <Table responsive bordered>
          <thead>
            <tr>
              <th>
                <span class="header-label" on:click={() => sortData('RequestStatus')}>
                  Request Status
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('RequestStatus', 'Request Status')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['RequestStatus'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('RequestDate')}>
                  Request Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('RequestDate', 'Request Date')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['RequestDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('EmployeeName')}>
                  Employee
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('EmployeeName', 'Employee')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['EmployeeName'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('TimeOffTypeLabel')}>
                  Timeoff Label
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('TimeOffTypeLabel', 'Timeoff Label')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['TimeOffTypeLabel'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('StartDate')}>
                  Start Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('StartDate', 'Start Date')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['StartDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('EndDate')}>
                  End Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('EndDate', 'End Date')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['EndDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('TotalHours')}>
                  Total Hours
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('TotalHours', 'Total Hours')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['TotalHours'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('ApproverName')}>
                  Approver
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ApproverName', 'Approver')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['ApproverName'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Notes')}>
                  Notes
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Notes', 'Notes')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Notes'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {#each displayedData as list}
              <tr>
                <td>
                  <span class="res-view-title">Request Status</span>
                  {list.RequestStatus === null ? 'N/A' : list.RequestStatus}
                </td>
                <td>
                  <span class="res-view-title">Request Date</span>
                  {list.RequestDate === null ? 'N/A' : list.RequestDate}
                </td>
                <td>
                  <span class="res-view-title">Employee</span>
                  {list.EmployeeName}
                </td>
                <td>
                  <span class="res-view-title">Timeoff Label</span>
                  {list.TimeOffTypeLabel === null ? 'N/A' : list.TimeOffTypeLabel}
                </td>
                <td>
                  <span class="res-view-title">Start Date</span>
                  {list.StartDate === null ? 'N/A' : list.StartDate}
                </td>
                <td>
                  <span class="res-view-title">End Date</span>
                  {list.EndDate === null ? 'N/A' : list.EndDate}
                </td>
                <td>
                  <span class="res-view-title">Total Hours</span>
                  {list.TotalHours === null ? 'N/A' : list.TotalHours}
                </td>
                <td>
                  <span class="res-view-title">Approver</span>
                  {list.ApproverName === null ? 'N/A' : list.ApproverName}
                </td>
                <td>
                  <span class="res-view-title">Notes</span>
                  {list.Notes === null ? 'N/A' : list.Notes}
                </td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>

      {#if displayedData.length <= 0}
        <div class="no-result-container">
          No Data
        </div>
      {/if}

    {/if}
  </div>
</div>

<ColumnFilterModal bind:this={columnFilterModal} on:filter={evt => updateFilters(evt.detail.field, evt.detail.value)}></ColumnFilterModal>
